var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"message-alert",attrs:{"show":_vm.show,"variant":_vm.alertVariant}},[_c('i',{class:_vm.alertIcon}),_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }